import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit {
  title: string;
  content: string;
  confirm: string;

  constructor( @Inject(MAT_DIALOG_DATA) public data: any) {
      this.title = data.title;
      this.content = data.content;
      this.confirm = data.confirm;
    }

  ngOnInit() {}

}
